import { render, staticRenderFns } from "./retainAllList.vue?vue&type=template&id=a0880fc4&scoped=true&"
import script from "./retainAllList.vue?vue&type=script&lang=js&"
export * from "./retainAllList.vue?vue&type=script&lang=js&"
import style0 from "./retainAllList.vue?vue&type=style&index=0&id=a0880fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0880fc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0880fc4')) {
      api.createRecord('a0880fc4', component.options)
    } else {
      api.reload('a0880fc4', component.options)
    }
    module.hot.accept("./retainAllList.vue?vue&type=template&id=a0880fc4&scoped=true&", function () {
      api.rerender('a0880fc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/components/retainAllList.vue"
export default component.exports